import { IMAGES } from "./images";

// Categories & subcategories mock data. Backend: replace via categoriesService.
export const CATEGORIES = [
  {
    id: "cat-water",
    name: "Water Purification Systems",
    slug: "water-purification-systems",
    brandSlug: "neptec",
    image: IMAGES.category["water-purification-systems"],
    shortDescription:
      "Type 1, 2 and 3 ultrapure, pure and RO water systems for laboratory and clinical reagent-grade water.",
    description:
      "A complete range of ultrapure (Type 1), pure (Type 2) and reverse-osmosis (Type 3) water purification systems, including clinical laboratory reagent water (CLRW) solutions engineered by Neptec.",
    subcategories: [
      { id: "sub-t1", name: "Ultrapure Water System (Type 1)", slug: "ultrapure-water-type-1" },
      { id: "sub-t12", name: "Ultrapure and Pure Water System (Type 1 + 2)", slug: "ultrapure-pure-water-type-1-2" },
      { id: "sub-t13", name: "Ultrapure and RO Water System (Type 1 + 3)", slug: "ultrapure-ro-water-type-1-3" },
      { id: "sub-t2", name: "Pure Water System (Type 2)", slug: "pure-water-type-2" },
      { id: "sub-t3", name: "RO Water System (Type 3)", slug: "ro-water-type-3" },
      { id: "sub-clrw", name: "CLRW (Clinical Lab Reagent Water) System", slug: "clrw-system" },
    ],
  },
  {
    id: "cat-glassware",
    name: "Glassware Washers",
    slug: "glassware-washers",
    brandSlug: "eurping",
    image: IMAGES.category["glassware-washers"],
    shortDescription:
      "Laboratory glassware washing systems engineered for consistent, validated cleaning performance.",
    description:
      "A range of laboratory glassware washers by Eurping designed for dependable, repeatable cleaning of laboratory glassware and labware.",
    subcategories: [],
  },
  {
    id: "cat-balances",
    name: "Balances",
    slug: "balances",
    brandSlug: "ohaus",
    image: IMAGES.category["balances"],
    shortDescription:
      "Analytical, semi-micro and precision laboratory balances for accurate weighing.",
    description:
      "Precision, analytical and semi-micro laboratory balances by Ohaus, built for accurate and reliable weighing across scientific applications.",
    subcategories: [],
  },
];

export const getCategoryBySlug = (slug) => CATEGORIES.find((c) => c.slug === slug);
export const getSubcategory = (categorySlug, subSlug) => {
  const cat = getCategoryBySlug(categorySlug);
  return cat?.subcategories.find((s) => s.slug === subSlug) || null;
};
